import {
	DataBoxConnectDialogVariant,
	useDataBoxConnectDialog,
} from '@gov-nx/module/data-box';
import { DataBoxConnectDialogForm } from './DataBoxConnectDialogForm';

export const DataBoxConnectListener = () => {
	const { mainKey, ts, modalVariant, closeModal } = useDataBoxConnectDialog();
	const isOpen = modalVariant !== DataBoxConnectDialogVariant.Closed;

	if (!isOpen) {
		return null;
	}

	return (
		<DataBoxConnectDialogForm
			isOpen={isOpen}
			mainKey={mainKey}
			modalVariant={modalVariant}
			closeModal={closeModal}
			ts={ts}
		/>
	);
};
